import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowPathRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-path-right" maskId="round-filled-radius-1-stroke-1.5-IconArrowPathRight"><path d="M15.0657 4.3931C14.2554 3.69536 13 4.27103 13 5.34031V7.99992H3.75C2.7835 7.99992 2 8.78342 2 9.74992V14.2499C2 15.2164 2.7835 15.9999 3.75 15.9999H13V18.6595C13 19.7288 14.2554 20.3045 15.0657 19.6067L22.3594 13.326C23.1702 12.6278 23.1702 11.372 22.3594 10.6738L15.0657 4.3931Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowPathRight;
